import { render, staticRenderFns } from "./scholarship.vue?vue&type=template&id=2250e30e&scoped=true"
import script from "./scholarship.vue?vue&type=script&lang=js"
export * from "./scholarship.vue?vue&type=script&lang=js"
import style0 from "./scholarship.vue?vue&type=style&index=0&id=2250e30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250e30e",
  null
  
)

export default component.exports